export const legendConfig = {
  proposed: {
    label: 'Proposed Measures',
    color: '#C2B3D8',
  },
  inProgress: {
    label: 'In-progress Measures',
    color: '#597EF7',
  },
  completed: {
    label: 'Completed Measures',
    color: '#52C41A',
  },
};
